import React from 'react'
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../core/common/textFields/TextField';

const DetailsMarkAsDead = ({ setComment, comment, setDeadWizardState, deadWizardState, projectLookups }: any) => {
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    return (
        <div className='row'>
            <div className="col-md-12">
                <label className="input-label">
                    Reason <span className='text-danger'>*</span>
                </label>
                <Select
                    styles={customStyles}
                    className="select"
                    options={projectLookups?.result?.Lst_MarkAsDeadReason?.map((option: any) => ({
                        label: option?.value,
                        value: option?.id
                    }))}
                    placeholder='Select Reason'
                    value={
                        {
                            value: deadWizardState?.value,
                            label: deadWizardState?.label || 'Select Reason',
                        }
                    }
                    onChange={(selectedOption: any) => {
                        setDeadWizardState(selectedOption)
                    }}
                />
            </div>
            <div className="col-md-12">
                <div className='col-md-12'>
                    <label>Comments </label>
                    <textarea
                        className='form-control'
                        rows={5}
                        style={{ width: '100%' }}
                        value={comment}
                        onChange={(e: any) => setComment(e.target?.value)}
                    />
                </div>
            </div>
        </div>
    )
}

export default DetailsMarkAsDead